module.exports = __webpack_public_path__ + "img/nigiri-single.baaf85b2.png";